// extracted by mini-css-extract-plugin
module.exports = {"rateCard":"RateCard_rateCard__167eg","data":"RateCard_data__3KCJp","value":"RateCard_value__1zOD8","chip":"RateCard_chip__L3RWE"};